import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const SummaryCardSkeleton = () => (
  <Card className="h-full min-h-[96px] border-border/70 bg-card/95 shadow-sm">
    <CardContent className="space-y-2 p-3">
      <Skeleton className="h-3 w-28" />
      <Skeleton className="h-7 w-24" />
      <Skeleton className="h-3 w-40" />
    </CardContent>
  </Card>
);

export default SummaryCardSkeleton;
